import {
    ADD_API_CONFIGURATION,
    GET_API_CONFIGURATION,
    ALL_API_CONFIGURATION,
    EDIT_API_CONFIGURATION
 } from "./actionTypes"
 
 export const addApiConfiguration = (data,history) => {
   return {
     type: ADD_API_CONFIGURATION,
     payload: { data,history},
   }
 }

 export const getApiConfiguration = (data) => {
   return {
     type: GET_API_CONFIGURATION,
     payload: {data},
   }
 }

 export const allApiConfiguration = data => {
   return {
     type: ALL_API_CONFIGURATION,
     payload: data,
   }
 }

 export const editApiConfiguration = (data,history) => {
   return {
     type: EDIT_API_CONFIGURATION,
     payload:{data,history},
   }
 }